import React from "react";
import "../../../CSS/WhyChooseSlash.css"
import SlashCoinsIcon from '../../../Assets/WhyChooseSlashCoinsIcon.png'
import HomeIcon from '../../../Assets/WhyChooseSlashHomeIcon.png'
import VerifiedIcon from '../../../Assets/whyChooseSlashVerifiedIcon.png'
import WhyChooseSlashStoreIcon from '../../../Assets/WhyChooseSlashStoreIcon.png'


const WhyChooseSlash = (selectedServiceTab) => {
    const features = [
  {
    icon: VerifiedIcon,
    title: "Verified Professionals",
    description:
      "Background-verified professionals trusted to deliver quality services at your home.",
  },
  {
    icon: selectedServiceTab == 'at_home' ? HomeIcon : WhyChooseSlashStoreIcon,
    title: selectedServiceTab == 'at_home' ? "Convenience at home" : "Trusted Stores near you",
    description: selectedServiceTab == 'at_home' ? "Slash brings experienced professionals to your doorstep." : "Discover services offered by trusted professionals at verified stores close to you.",
  },
  {
    icon: SlashCoinsIcon,
    title: "Earn Slash Coins with Every booking",
    description:
      "Book services through the Slash app and earn Slash Coins—our way of rewarding you for every completed service.",
  },
];
  return (
    <div className="why-choose-slash-container">
      <h2 className="why-choose-slash-title">Why Choose Slash?</h2>
      <h3 className="why-choose-slash-subtitle">
        Because finding the right service should feel simple, personal,
        and reliable — every single time.
      </h3>

      <div className="why-choose-slash-card-wrapper">
        {features.map((item, index) => (
          <div className="why-choose-slash-card" key={index}>
            <img src={item.icon} className="why-choose-slash-icon" />
            <h3 className="why-choose-slash-card-title">{item.title}</h3>
            <p className="why-choose-slash-card-description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseSlash;
